import '../styles/LandingApplyFoot.css';
import React from 'react';

function LandingApplyFoot() {
  return (
    <section className="laf-root" aria-labelledby="laf-heading">
      <div className="laf-wrap" data-content-rail="primary">
        <span className="laf-numeral" aria-hidden="true">03</span>

        <svg
          className="laf-arc"
          viewBox="0 0 1200 54"
          preserveAspectRatio="none"
          aria-hidden="true"
          focusable="false"
        >
          <path className="laf-arc--ghost" d="M0 50 C 300 2, 900 2, 1200 50" />
          <path d="M0 50 C 300 2, 900 2, 1200 50" />
        </svg>

        <div className="laf-body">
          <p className="laf-kicker">
            <span className="laf-kicker-dot" aria-hidden="true" />
            Ready when you are
          </p>

          <h2 id="laf-heading" className="laf-heading">Apply for a Montreaux loan</h2>

          <div className="laf-row">
            <a className="laf-apply" href="/apply">
              Apply for a loan
              <svg className="laf-apply-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a className="laf-loans" href="/loans">
              Re-read the loan information
              <svg className="laf-loans-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M5 12h13M12 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingApplyFoot;